import './App.css';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useContext } from 'react';
import { UserContext } from './contexts/user';
import NavBar from './components/NavBar';
import LogInUser from './pages/Auth/LogInUser';
import CreateProfile from './pages/Main/CreateProfile';
import MyAssessments from './pages/Main/MyAssessments';
import WelcomeAssessment from './pages/Main/WelcomeAssessment';
import AssessmentBlock from './pages/Main/AssessmentBlock';
import CompletedAssessment from './pages/Main/CompletedAssessment';
import ReportAssessment from './pages/Main/ReportAssessment';
import LoginAdmin from './pages/Auth/LoginAdmin';
import ForgotPassword from './pages/Auth/ForgotPassword';
import Dashboard from './pages/Admin/Dashboard';
import Assessment360 from './pages/Main/Assessment360';
import ClientSetup from './pages/Main/ClientSetup';
import GroupsReport from './pages/Main/GroupsReport';


function App() {

  const {currentUser} = useContext(UserContext);

  return (
    <>
      <Routes>
        {
          !currentUser && <>
            <Route path="/" element={<NavBar/>}>
              <Route index element={<LogInUser/>}/>
              <Route path="/admin" element={<LoginAdmin/>}/>
              <Route path="/admin/forgot-password" element={<ForgotPassword/>}/>
              <Route path="/360/:assessmentSlug/:userEvalId/:userId/:groupId" element={<Assessment360/>}/>
              <Route path="/setup/:token" element={<ClientSetup/>}/>
            </Route>
            <Route path='*' element={<Navigate to="/"/>}/>
          </>
        }
        {
          currentUser && currentUser.rol === "user" && <>
            <Route path="/" element={<NavBar/>}>
              <Route index element={<MyAssessments/>}/>
              <Route path="/360/:assessmentSlug/:userEvalId/:userId/:groupId" element={<Assessment360/>}/>
              <Route path="/setup/:token" element={<ClientSetup/>}/>
              <Route path="/create_profile" element={<CreateProfile/>}/>
              <Route path="/:slugAssessment" element={<WelcomeAssessment/>}/>
              <Route path="/:slugAssessment/complete" element={<CompletedAssessment/>}/>
              <Route path="/:slugAssessment/groups/report" element={<GroupsReport/>}/>
              <Route exact path="/:slugAssessment/:groupId/report" element={<ReportAssessment/>}/>
              <Route path="/:slugAssessment/report" element={<ReportAssessment/>}/>
              <Route path="/:slugAssessment/:slugBlock" element={<AssessmentBlock/>}/>
            </Route>
          </>
        }
        {
          currentUser && currentUser.rol === "admin" && <>
            <Route path="/" element={<NavBar/>}>
              <Route index element={<Dashboard active={"home"}/>}/>
              <Route exact path="/profile/:userId" element={<Dashboard active={"profile"}/>}/>
              <Route exact path="/profile/:slugAssessment/:userId" element={<Dashboard active={"report"}/>}/>
              <Route path="/assessment/:slugAssessment" element={<Dashboard active={"assessment"}/>}/>
              <Route exact path="/:slugAssessment/:groupId/:reportUserId/report" element={<ReportAssessment/>}/>
              <Route exact path="/:slugAssessment/:groupId/report" element={<ReportAssessment/>}/>
              <Route path="/users" element={<Dashboard active={"users"}/>}/>
              <Route path="/email-templates" element={<Dashboard active={"email_templates"}/>}/>
              <Route path="/setup/:token" element={<ClientSetup/>}/>
              {/* <Route exact path="/:userId" element={<Dashboard active={"profile"}/>}/> */}
            </Route>
            <Route path='*' element={<Navigate to="/"/>}/>
          </>
        }
      </Routes>
    </>
);
}

export default App;
